import { render } from "./AExpansionPanels.vue?vue&type=template&id=2886b964"
import script from "./AExpansionPanels.vue?vue&type=script&lang=js"
export * from "./AExpansionPanels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__